import React, { useCallback, useEffect, useRef, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';
import {Button } from "@communicare/medications/Components/Button";
import { ButtonGroup, DialogActions, DialogContent, IconButton } from '@material-ui/core';
import { CloseIcon } from '@communicare/medications/Components/Icons';
import { ClosingTheGapStatusEnum } from '../../enums/ClosingTheGapStatus';
import styles  from './ResidentDetailsDialogStyles.module.css';
import {  ContactSection, PanelSection } from '../ResidentDetailsDialogSection';
import cx from "classnames";
import { Patient } from '../../../../services/medicationmanagement/patientApi/models/Patient';
import {ReactComponent as FacilityIcon} from "../../../../images/facility-fill.svg";
import { DateDisplay } from '../../date-display/DateDisplay';
import { DateFormats } from '../../enums/DateFormat';
import moment from 'moment';
import { DnarIcon } from '../../dnar-icon/DnarIcon';

export interface ResidentDetailsDialogProps {
  open: boolean;
  size?: 'xxs' | 'xs' | 'sm' | 'md' | 'lg' | false;
  selectedValue: any;
  HeaderTitle : string;
  ConsentTitle? : string;
  ConsentSubTitle? : string;
  ConsentText : string;
  onSave: (value: string) => Promise<boolean>;
  panelSection: string;
  contactSection: string;
  handleClose: () => void;
  resident: Patient;
  showConsent: boolean;
}

export const ResidentDetailsDialog = (props: ResidentDetailsDialogProps) => {
    const { onSave} = props;
    const [openDialog, setOpenDialog] = React.useState(false);
    const [selectedValue, setSelectedValue] = React.useState(props.selectedValue);
    const [panelSection, setPanelSection] = useState("");


    const handleClose = () => {
        props.handleClose();
     };

     const handleSelect = (selectedValue: string) => {
        setSelectedValue(selectedValue);
     }

     const handleSave = () => {
         onSave(selectedValue);
     }

    useEffect(() => {
        setSelectedValue(props.selectedValue);
        setOpenDialog(props.open);
    }, [props.open]);

    let paperMinWidth: string = '';
    let paperMaxWidth: string = '';

    switch(props.size) {
        case 'xs':
        case 'xxs':
            paperMinWidth = '640px';
            paperMaxWidth = '640px';
            break;
        case 'sm':
            paperMinWidth = '840px';
            paperMaxWidth = '840px';
            break;
        case 'md':
            paperMinWidth = '980px';
            paperMaxWidth = '640px';
            break;
        default:
            paperMinWidth = '1280px';
            paperMaxWidth = '640px';
    }

    // material ui dialog override css classes
    const useStyles = makeStyles({
        root: {
            margin: 0,
            padding: 0
          },
          container: {

          },
          paper: {
              minWidth: paperMinWidth,
              maxWidth: paperMaxWidth,
              height: '700px',
              minHeight: '500px',
              overflow: 'hidden',
              margin:0,
              padding:0
          }
    });

    const modalRef = useRef<HTMLElement>(null);
    const facilityDiv = useRef<HTMLDivElement>(null);
    const prescriberDiv = useCallback(node => {
        if (node !== null) {           
            if(props.contactSection === ContactSection.Prescriber){
              node.scrollIntoView({ behavior: 'smooth' });
            }
        }
    }, [props.contactSection]);
    const pharmacistDiv = useCallback(node => {
        if (node !== null) {
            if(props.contactSection === ContactSection.Pharmacist){
              node.scrollIntoView({ behavior: 'smooth' });
            }
        }
    }, [props.contactSection]);


const getTime = (dateTime: Date) => {
    return moment(dateTime).format('HH:mm');
};
const overrideClasses = useStyles();
useEffect(() => {
    setPanelSection(props.panelSection);
},[props.panelSection]);

  return (
        <Dialog id='modal' ref={modalRef} onClose={() => handleClose} onBackdropClick={() => handleClose} aria-labelledby="customized-dialog-title" open={openDialog} classes= {overrideClasses}>
            <DialogTitle id="dialog-title" className = {styles.dialogTitle} >
            <div className = {styles.titleTextBlock}>
                {props.HeaderTitle}
            </div>
            <div className = {styles.titleCloseButtonBlock}>
                <IconButton aria-label="close" className={styles.closeButton} onClick={() => handleClose()} >
                    <CloseIcon color='white'/>
                </IconButton>
            </div>
            </DialogTitle>
            <DialogContent className= {styles.contentPanel}>
                <div className= {styles.leftPanel}>
                    {props.showConsent && (
                    <a className={cx(styles.leftPanelTitle, { [styles.leftPanelTitleSelected]: panelSection === PanelSection.Consent })} onClick={() =>
                        setPanelSection(PanelSection.Consent)}>
                        <span className={styles.topMarginZero}><DnarIcon name='consent-fill' color={panelSection === PanelSection.Consent ? 'B2' : ''}></DnarIcon> </span>
                        <span className={cx(styles.lineHeight, styles.topMargin10)}>Consent
                        </span>
                    </a>)}
                    <a className= {cx(styles.leftPanelTitle ,{[styles.leftPanelTitleSelected] : panelSection === PanelSection.Contacts})} onClick={() => setPanelSection(PanelSection.Contacts)} >
                        <span className={styles.topMarginZero}><DnarIcon name='importContacts-fill' color={panelSection === PanelSection.Contacts ? 'B2' : ''}></DnarIcon> </span>
                        <span className={cx(styles.lineHeight, styles.topMargin10)}>Contacts
                        </span>
                    </a>
                </div>
            <div className={styles.scrollArea} id='modal-content'>
            {panelSection === PanelSection.Consent &&(
            <div className= {styles.rightPanel}>
                <div className = {styles.consentContainer}>
                    <div className = {styles.consentTitle}>{props.ConsentTitle}</div>
                    <div className = {styles.consentActionPanel}>
                        <div className = {styles.consentActionPanelLeft}>
                            <div className = {styles.consentSubTitle}>
                                {props.ConsentSubTitle}
                            </div>
                            <div className = {styles.consentText}>
                                {props.ConsentText}
                            </div>
                        </div>
                        <div className = {styles.consentActionPanelRight}>
                            <ButtonGroup size="small" aria-label="consent action" className = {styles.consentActionPanelButtonGroup}>
                                <Button testId='button-Accept' className = {(selectedValue == ClosingTheGapStatusEnum.Yes)? styles.active : ''} onClick= {() => handleSelect(ClosingTheGapStatusEnum.Yes)}>Accept</Button>
                                <Button testId='button-NoAnswer' className = {(selectedValue == ClosingTheGapStatusEnum.NotSpecified)? styles.active : '' } onClick= {() => handleSelect(ClosingTheGapStatusEnum.NotSpecified)}>No answer</Button>
                                <Button testId='button-Decline' className = {(selectedValue == ClosingTheGapStatusEnum.No)? styles.active : ''} onClick= {() => handleSelect(ClosingTheGapStatusEnum.No)}>Decline</Button>
                            </ButtonGroup>
                        </div>
                    </div>
                </div>
                <div className = {styles.dialogFooter}>
                    <div className = {styles.dialogFooterContainer}>
                        <DialogActions className = {styles.dialogFooterButtons}>
                            <Button testId='button-Close' className = {styles.dialogFooterButton} onClick={() => handleClose()}>
                                Close
                            </Button>
                            <Button testId='button-Save' className = {[styles.dialogFooterButton, styles.saveButton].join(' ')} onClick={() => handleSave()}>
                                Save
                            </Button>
                        </DialogActions>
                    </div>
                </div>
            </div>
            )}
            {panelSection === PanelSection.Contacts &&(
                <div className= {styles.rightPanel}>
                    <div className = {styles.container}>
                        <div id='facility' ref={facilityDiv}>
                            <div>
                                <div className={cx(styles.inline, styles.rightGap5)}><FacilityIcon></FacilityIcon></div>
                                <div className={styles.inlineTopAlign}><span className = {styles.contactTitle}>
                                    Facility: <span className={styles.contactTitleBold}>{props.resident?.facilityDetails.name}</span></span>
                                </div>
                            </div>
                            <div className = {styles.contactRow}>
                                <div className = {styles.contactLabel}>
                                  <span className={styles.alert}>* </span>Address line 1
                                </div>
                                <div className={styles.contactText}>
                                    {props.resident?.facilityDetails.address1}
                                </div>
                            </div>
                            <div className = {styles.contactRow}>
                                <div className = {styles.contactLabel}>
                                    <span className={styles.alert}>* </span>Address line 2
                                </div>
                                <div className={styles.contactText}>
                                    {props.resident?.facilityDetails.address2}
                                </div>
                            </div>
                            <div className = {styles.contactRow}>
                                <div className = {styles.contactColumn}>
                                    <div className={styles.contactLabel}>Suburb</div>
                                    <div className={styles.contactText}>{props.resident?.facilityDetails.suburb}</div>
                                </div>
                                <div className = {styles.contactColumn}>
                                    <div className={styles.contactLabel}>State</div>
                                    <div className={styles.contactText}>{props.resident?.facilityDetails.state}</div>
                                </div>
                                <div className = {styles.contactColumn}>
                                    <div className={styles.contactLabel}>Postcode</div>
                                    <div className={styles.contactText}>{props.resident?.facilityDetails.postcode}</div>
                                </div>
                            </div>
                            <div className = {styles.contactRow}>
                                <div className = {styles.contactLabel}>
                                    Phone
                                </div>
                                <div className={styles.contactText}>
                                    {props.resident?.facilityDetails.phone}
                                </div>
                            </div>
                        </div>

                        <div id='prescriber' ref={prescriberDiv}>
                            {props.resident?.contacts?.recentActivePrescribers.length>0 && <hr className={styles.separator}></hr>}
                            {props.resident?.contacts?.recentActivePrescribers.map((prescriber, indx) => {
                            return (<>
                                <div className = {styles.contactTitle}>
                                <div className={cx(styles.inline, styles.rightGap5)}><DnarIcon name="gp-fill"></DnarIcon></div>
                                   <div className={styles.inlineTopAlignWithHeight}>
                                    <span className={styles.contactTitleBold}>{prescriber.givenName} {prescriber.familyName} </span>
                                     <span className={styles.whiteSpace}>(prescriber active on
                                        &nbsp;
                                        <DateDisplay
                                        date={prescriber.activeDate.toString()}
                                        format={DateFormats.DDMMMYYYYHyphen}
                                        isTextBold={true}
                                        />
                                        &nbsp;at&nbsp;
                                        <b>{getTime(prescriber.activeDate)}</b>
                                       )
                                     </span>
                                    </div>
                                </div>
                                <div className = {styles.contactRow}>
                                    <div className = {styles.contactColumn}>
                                        <div className = {styles.contactLabel}>
                                            <span className={styles.alert}>* </span>First name/ given name
                                        </div>
                                        <div className={styles.contactText}>
                                            {prescriber.givenName}
                                        </div>
                                    </div>
                                    <div className = {styles.contactColumn}>
                                        <div className = {styles.contactLabel}>
                                            <span className={styles.alert}>* </span>Last name/ surname
                                        </div>
                                        <div className={styles.contactText}>
                                            {prescriber.familyName}
                                        </div>
                                    </div>
                                </div>
                                {indx < props.resident?.contacts?.recentActivePrescribers.length-1 &&
                                <hr className={styles.separator}></hr>
                                }
                            </>
                            )})}
                     </div>
                        <div id='pharmacist' ref={pharmacistDiv}>
                        {props.resident?.contacts?.recentActivePharmacists.length>0 && <hr className={styles.separator}></hr>}
                        {props.resident?.contacts?.recentActivePharmacists.map((pharmacist, indx) => {
                            return (<>
                                <div className = {styles.contactTitle}>
                                <div className={cx(styles.inline, styles.rightGap5)}><DnarIcon name="pharmacy-fill"></DnarIcon></div>
                                <div className={styles.inlineTopAlignWithHeight}>
                                    <span className={styles.contactTitleBold}>{pharmacist.givenName} {pharmacist.familyName}</span>
                                    <span className={styles.whiteSpace}>(pharmacist active on
                                        &nbsp;
                                        <DateDisplay
                                        date={pharmacist.activeDate.toString()}
                                        format={DateFormats.DDMMMYYYYHyphen}
                                        isTextBold={true}
                                        />
                                        &nbsp;at&nbsp;
                                        <b>{getTime(pharmacist.activeDate)}</b>
                                    )</span>
                                </div>
                                </div>
                                <div className = {styles.contactRow}>
                                    <div className = {styles.contactColumn}>
                                        <div className = {styles.contactLabel}>
                                            <span className={styles.alert}>* </span>First name/ given name
                                        </div>
                                        <div className={styles.contactText}>
                                            {pharmacist.givenName}
                                        </div>
                                    </div>
                                    <div className = {styles.contactColumn}>
                                        <div className = {styles.contactLabel}>
                                            <span className={styles.alert}>* </span>Last name/ surname
                                        </div>
                                        <div className={styles.contactText}>
                                            {pharmacist.familyName}
                                        </div>
                                    </div>
                                </div>
                                {indx < props.resident?.contacts?.recentActivePharmacists.length-1 &&
                                <hr className={styles.separator}></hr>
                                }
                            </>)
                            })}
                        </div>
                    </div>

                     <div className={styles.bottomPadding40}></div> 

                    <div className = {styles.dialogFooter}>
                    <div className = {styles.dialogFooterContainer}>
                        <DialogActions className = {styles.dialogFooterButtons}>
                            <Button testId='button-Close' className = {styles.dialogFooterButton} onClick={() => handleClose()}>
                                Close
                            </Button>
                        </DialogActions>
                    </div>


                    </div>
                </div>
            )}
            </div>
        </DialogContent>
    </Dialog>
  );
}
